import _ = require("underscore");
import Utils = require("../utils");
import Portal = require("portal-gis");
import View = require("./view");

class Tool extends View {

    static about = `
Display a basemap carousel
    `;

    private get basemaps() {
        let collection = this.mediator.api.layers;
        collection = this.view.collection || collection;
        return collection.filter(l => !l.data.disabled && !!l.data.basemap);
    }

    private showBasemap(id: string) {

        let basemap = this.basemaps.filter(b => b.id === id)[0];

        this.mediator.mapView(mapView => {

            this.basemaps.filter(b => b !== basemap).forEach(b => {
                mapView.hideLayer(b.id);
                b.set("visible", false);
            });

            if (basemap) {
                basemap.set("visible", true);
                mapView.showLayer(basemap.id);

                this.trigger({
                    basemap: basemap
                });
            }

        });

        return basemap;
    }

    execute(args = this.args) {
        console.log("display a basemap carousel");

        let options = _.defaults(this.options, {
            "allow-multi": "false",
            view: "app/views/BasemapView",
            region: "maplet-region",
            model: this.mediator.api.layers,
            template: "app/templates/basemap-template"
        });


        if (!options["default-basemap"]) {
            if (options["allow-multi"] !== "true") {
                let visible = this.basemaps.filter(b => b.get("visible") !== false);
                if (visible.length) {
                    options["default-basemap"] = visible[0].id;
                }
            }
        }

    }

    setViewOptions(options) {
        //{
        //    // TODO: create asView on Collection
        //    let basemapView = new LayerCollection();
        //    this.basemaps.forEach(l => basemapView.merge(l.data));
        //    options.collection = basemapView;
        //}
        _.defaults(options, {
            "default-basemap": this.options["default-basemap"]
        });
        return options;
    }

    broadcast() {

        // show requires map, make sure it's set (could be a startup command)
        this.mediator.mapViewMap(map => {

            Utils.ifOption(this.options, "default-basemap", v => this.showBasemap(v));

            this.view.on("change", (args: { value: string }) => {
                this.showBasemap(args.value);
            });

        });

        super.broadcast();
    }
}

export = Tool;  